import { render, staticRenderFns } from "./Base.vue?vue&type=template&id=2832ad7c&lang=pug&"
import script from "./Base.vue?vue&type=script&lang=js&"
export * from "./Base.vue?vue&type=script&lang=js&"
import style0 from "./Base.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/rain/projects/themes/achernar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2832ad7c')) {
      api.createRecord('2832ad7c', component.options)
    } else {
      api.reload('2832ad7c', component.options)
    }
    module.hot.accept("./Base.vue?vue&type=template&id=2832ad7c&lang=pug&", function () {
      api.rerender('2832ad7c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/admin/edit/Base.vue"
export default component.exports